export default import.meta.ROLLDOWN_FILE_URL_SBvmHQigMJAF8o1IgK_XnQ